/**
 * Секция формы с заголовком
 */
export const FormSection = ({ title, children, className = '' }) => {
  if (typeof title === 'string' && title.includes('Доступность')) {
    return null;
  }

  return (
    <div className={`mb-5 ${className}`}>
      {title && <h5 className="mb-4 pb-2 border-bottom">{title}</h5>}
      {children}
    </div>
  );
};
